"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var renderers = exports.renderers = require("./csr-renderers");

//fieldComponent = { name, onReady, render, getValue, locations:["View", "NewForm","DisplayForm", "EditForm"] }
// var renderColoredStatus = function(ctx) {
//     // map statuses  to colors
//     var colors = {
//         "Not Started": "orange",
//         "In Progress": "yellow",
//         "Done": "green"
//     };

//     // Look at the item's status to get the mapped color
//     // If the item has a status value that is not mapped, then use 'red'
//     var color = colors[ctx.CurrentItem.Status] || "red";

//     // return the html used to render the status field;
//     return "<h4 style='color:" + color + "'>" + ctx.CurrentItem.Status + "</h4>";
// };

// var fieldOverride = {
//     name:  "Status",
//     render: renderColoredStatus
// };

// SPScript.CSR.registerDisplayField(fieldOverride);

var registerFormField = exports.registerFormField = function (fieldComponent, opts) {
    var renderer = renderers.formField.create(fieldComponent);
    fieldComponent.locations = fieldComponent.locations || ["NewForm", "EditForm"];
    return registerField(fieldComponent, renderer, opts);
};

//{name, onReady, render, locations: ["View", "DisplayForm"]}
var registerDisplayField = exports.registerDisplayField = function (fieldComponent, opts) {
    var renderer = renderers.displayField.create(fieldComponent);
    fieldComponent.locations = fieldComponent.locations || ["View", "DisplayForm"];
    return registerField(fieldComponent, renderer, opts);
};

var registerField = exports.registerField = function (field, renderer, opts) {
    var renderers = {};
    //View, DisplayForm, EditForm, NewForm
    field.locations.forEach(function (l) {
        return renderers[l] = renderer;
    });
    var defaults = {
        Templates: {
            Fields: {}
        }
    };
    var templateOverride = _extends({}, defaults, opts);
    templateOverride.Templates.Fields[field.name] = renderers;
    SPClientTemplates.TemplateManager.RegisterTemplateOverrides(templateOverride);
    return field;
};

var registerView = exports.registerView = function (templates, options) {
    // templates keys are Header, Item, Footer
    //RenderFieldTemplateDefault(ctx); default renderer?
    var defaults = {
        //BaseViewID
        //ListTemplateType
        Templates: {
            Header: function Header() {
                return "";
            },
            Footer: function Footer() {
                return "";
            }
        }
    };

    var templateOverride = _extends({}, defaults, options);
    templateOverride.Templates = _extends({}, templateOverride.Templates, templates);

    SPClientTemplates.TemplateManager.RegisterTemplateOverrides(templateOverride);
};
//# sourceMappingURL=csr.js.map


//////////////////
// WEBPACK FOOTER
// ./~/spscript/lib/csr.js
// module id = 57
// module chunks = 0